import ClassListModelBase from '../_generated/modelBases/class-list-model-base';

export default class ClassListModel extends ClassListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
